import gql from 'graphql-tag';
import FieldsBooking from 'graphql/fields/FieldsBooking'

export default gql(`
	query qrcode_old( $guid: String! ){
		qrcode_scanin( guid: $guid ) {
			guid
			data
			
			booking {
				${FieldsBooking}
			}
		}
	}
`);

